import { PageContainer } from '@/shared/ui/PageContainer';

export const AboutPage = () => {
  return (
    <PageContainer>
      <h3>Служебная информация</h3>
      <p>Страница служебной информации</p>
    </PageContainer>
  );
};
